import { isNil } from 'lodash';

import { ENTITY_TYPES } from '@shared/types/enums';
import { getSingularEntityName } from '../configs/entity-name-config';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

export const EDITOR_MESSAGES = {
  /**
   * @param entityDescription will use this to override entityType message
   */
  customConfirmation: ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    title,
    entityType,
    entityDescription,
    withoutFormText = false,
    i18nService,
  }: {
    title?: string;
    entityType?: ENTITY_TYPES;
    entityDescription?: string;
    withoutFormText?: boolean;
    i18nService: XVII18nService;
  }): string => {
    return i18nService
      .instant(I18n.ConfirmMessages.DiscardUnsavedChanges, {
        entityDescription: i18nService.instant(
          !isNil(entityDescription)
            ? entityDescription
            : getSingularEntityName(entityType),
        ),
        formText: withoutFormText
          ? ''
          : ` ${i18nService.instant(I18n.Forms.GridForm.form)}`,
      })
      ?.replace(/\s+/g, ' ');
  },
  customTitle: (entityType: string): string =>
    EXIT_TITLE[entityType] || I18n.Common.Confirm,
};

export const EXIT_TITLE = {};

export const TOASTER_SUCCESS_MESSAGE = {
  title: I18n.Common.SUCCESS,
  message: I18n.InfoMessages.ActionWasSuccessfullyDone,
};

export const TOASTER_ERROR_MESSAGE = {
  title: I18n.Common.ERROR,
};

export const TOASTER_WARNING_MESSAGE = {
  title: I18n.Common.WARNING,
};

export const TOASTER_SUBMITTED_SUCCESSFULLY_MESSAGE =
  I18n.InfoMessages.SubmittedSuccessfully;
export const TOASTER_SAVED_SUCCESSFULLY_MESSAGE =
  I18n.InfoMessages.SavedSuccessfully;
export const TOASTER_TRANSACTION_FAILED_MESSAGE =
  I18n.ErrorMessages.TransactionFailedPlsTryAgain;
export const TOASTER_ACTION_FAILED_MESSAGE =
  I18n.ErrorMessages.ActionFailedPlsTryAgain;
export const TOASTER_STAND_WORKSHEET_RE_INITIALIZE_SUCCESSFULLY_MESSAGE =
  'Re-initialized successfully';
export const TOASTER_STAND_WORKSHEET_RE_INITIALIZE_FAILED_MESSAGE =
  'Failed to re-initialize. Please try again later.';
export const TOASTER_FOR_OPENING_WORK_SHEET_LOADING_FAILED_MESSAGE =
  'Loading failed. Please try again later.';
